import { type Common } from './common.js';
import { type Preference } from './models/user/preferences.js';

export class API {
  common: Common;
  baseEndpoint = '/preferences';

  constructor(common: Common) {
    this.common = common;
  }

  async findOne(): Promise<Preference> {
    const url = this.common.constructPath(`${this.baseEndpoint}/me`);
    return await this.common.getJSON(url);
  }
}
